import React, { useState, useEffect } from "react";
import { Button, Row, Col, Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import moment from "moment";
import "./RendezVous.css";
import ServiceRdv from "./ServiceRdv/ServiceRdv";
import Navbar from "../../Member/Navbar/Navbar";
import DeleteIcon from "@material-ui/icons/Delete";
import DetailRdv from "../../Member/MesRdv/detailRdv";
import ListIcon from "@material-ui/icons/List";
import ServiceMesRdv from "../../Member/MesRdv/ServiceMesRdv/ServiceMesRdv";
const RendezVous = (props) => {
  const [userId, setId] = useState("");
  const [analyses, setAnalyses] = useState("");

  useEffect(() => {
    setId(JSON.parse(sessionStorage.getItem("user")).id);
    GetDataRdv();
  }, []);
  const GetDataRdv = () => {
    ServiceRdv.getRdvByAdmin(
      JSON.parse(sessionStorage.getItem("user")).id
      //userId
    ).then((res) => {
      setInfo(res.data);
    });
  };

  //get analyses by rdv id
  const GetAnalysesByRdvId = (rdvId) => {
    ServiceMesRdv.getAnalysesByRdv(rdvId).then((res) => {
      setAnalyses(res.data);
    });
  };

  const DeleteRdv = (id) => {
    ServiceRdv.deleterdv(id).then((res) => {
      setInfo(INFO.filter((x) => x.id !== id));
      setShow(false);
    });
  };

  const { SearchBar } = Search;

  const [INFO, setInfo] = useState([]);
  //pagination :
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      &thinsp; De {from} à {to} sur {size}
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,

    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "Plus",
        value: INFO.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };

  const columns = [
    {
      dataField: "nom",
      text: "Patient",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "personne",
      text: "Personne à Charge",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "date",
      text: "Date",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "hour",
      text: "Heure",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "designation",
      text: "Désignation",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "type",
      text: "Lieu",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    // {
    //   dataField: "analyse",
    //   text: "Préstation",
    //   headerAlign: "center",
    //   align: "center",
    //   sort: true,
    // },
    {
      dataField: "action",
      text: "Action",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
  ];

  const defaultSorted = [
    {
      dataField: "name",
      dataField: "id",
      dataField: "price",
      order: "desc",
    },
  ];
  //details rdv
  const [showDetail, setShowDetail] = useState(false);
  const ToggleAnalyse = () => {
    setShowDetail(false);
  };
  const infouser = [];

  INFO.map((info, i) => {
    infouser.push({
      nom: `${info.user.firstName} ${info.user.lastName} `,
      personne: info.personCharge
        ? `${JSON.parse(info.personCharge)[0].firstName} ${
            JSON.parse(info.personCharge)[0].lastName
          } `
        : "---",
      date: moment(info.dateform).format("DD/MM/YYYY"),
      hour: info.hour,
      designation: info.planning.designation,
      type: info.type,
      //analyse: info.analyse ? info.analyse.designation : "-",
      action: [
        <Button
          className="mr-2 print"
          variant="info"
          onClick={() => {
            GetAnalysesByRdvId(info.id);
            setShowDetail(true);
          }}
        >
          <ListIcon />
        </Button>,
        <Button
          variant="danger"
          onClick={() => {
            setIdRdv(info.id);
            setShow(true);
          }}
        >
          <DeleteIcon />
        </Button>,
      ],
    });
  });

  //popup annuler
  const [idRdv, setIdRdv] = useState("");
  const [show, setShow] = useState(false);
  const Toggle = () => {
    setShow(false);
  };

  // Implement startWith instead of contain
  function customMatchFunc({ searchText, value, column, row }) {
    if (typeof value !== "undefined") {
      return value.startsWith(searchText);
    }
    return false;
  }
  return (
    <>
      <Navbar />
      <div className="container">
        <DetailRdv
          analyse={analyses}
          show={showDetail}
          Toggle={ToggleAnalyse}
        />
        <Modal show={show} onHide={Toggle}>
          <Modal.Body>
            <img
              src="https://img.icons8.com/fluent/48/000000/close-window.png"
              style={{ float: "right" }}
              alt="close"
              onClick={Toggle}
            />
            <h6
              style={{
                marginTop: "27px",
                marginBottom: "18px",
                textAlign: "center",
              }}
            >
              Êtes-vous sûr d'annuler ce rendez-vous ?
            </h6>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="info" onClick={() => DeleteRdv(idRdv)}>
              Oui
            </Button>

            <Button className="mr-auto" variant="danger" onClick={Toggle}>
              Non
            </Button>
          </Modal.Footer>
        </Modal>
        <h3
          style={{
            borderRadius: "0.25em",
            textAlign: "center",
            border: "1px solid purple",
            padding: "0.5em",
            marginTop: "10px",
          }}
        >
          Liste des Rendez-vous
        </h3>

        <ToolkitProvider
          keyField="id"
          data={infouser}
          columns={columns}
          search={{ customMatchFunc }}
        >
          {(props) => (
            <div>
              <SearchBar {...props.searchProps} />

              <BootstrapTable
                striped
                {...props.baseProps}
                defaultSorted={defaultSorted}
                pagination={paginationFactory(options)}
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
    </>
  );
};

export default RendezVous;
